import React from 'react';
import { Row, Col } from 'antd'

const intl = {
  headline: {
    'en': 'ORGANIZATIONAL DYNAMICS',
    'dk': 'ORGANISATORISKE DYNAMIKKER'
  },
  quote: {
    'en': <div>
      iLEAD A/S addresses three levels: the organizational, groups and teams and the individual.
      <br/><br/>
      Regardless of which level we work on, we always consider the entirety of the organization. This big-picture perspective allows us to maintain context even when we focus on minute detail. The smallest issue with an individual or a team often is indicative of a broader organizational problem. By zooming in and out, we are able to help you identify areas for improvement that will affect both performance and culture. With our interventions, we are able to assist both the individual and the collective.
      <br/><br/>
      Our services are bespoke, developed and adapted to the needs of each client.
    </div>,
    'dk': <div>
      iLEAD A/S arbejder på tre niveauer; det organisatoriske, med grupper og teams og individet.
      <br/><br/>
      Uanset hvilket niveau vi arbejder på, er det med helheden for øje. Det holistiske perspektiv tillader os at fastholde kontekst selv når vi arbejder med organisatoriske detaljer. Udfordringer med individer eller teams er ofte indikatorer af et bredere organisatorisk problem. Ved at zoome ind og ud er vi ofte i stand til at identificere områder der kan forbedre både præstationer og kultur. Med vores fokuserede tilgang adresserer vi årsager fremfor symptomer.
      <br/><br/>
      Vores ydelser er ikke standardiserede, men udvikles og tilpasses til klientens behov og sammensætningen af iLEAD A/S team afspejler dette. Uanset hvor i verden vores klienter har brug for udvikling.
  </div>
  },
}
function Divider(props) {
  return (
    <Row style={{ backgroundColor: '#1abc9c', color: '#fff' }}>
      <Col sm={24} md={{ span: 14, offset: 5 }}>
        <Row gutter={24}>
          <Col sm={24} md={{ span: 24 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                height: '100%',
                textAlign: 'center',
              }}
            >
              <div id={props.anchorId} className="blog_block_content">
                <h3 style={{
                  color: '#fff',
                  fontSize: '25px',
                  paddingTop: '20px',
                  letterSpacing: '1px',
                }}>{intl.headline[props.language]}</h3>
                <p
                  style={{
                    color: '#fff',
                    fontSize: '14px',
                    textOverflow: 'ellipsis',
                    padding: '10px 0'
                  }}
                >
                  {intl.quote[props.language]}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Divider;



// WEBPACK FOOTER //
// ./src/pages/Methodology/Divider.js